import React, { useId } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

export default function FinancialStatementsAction({
  onGetFinancials,
  disabledReason = '',
  isLoading = false,
  disabled = false,
}) {
  const descriptionId = useId();
  const hasAction = typeof onGetFinancials === 'function';
  const reason = disabledReason || (!hasAction
    ? 'Financial statements are unavailable here. Reload the page or contact your platform administrator.'
    : '');
  const isDisabled = disabled || isLoading || Boolean(reason);
  const status = isLoading
    ? 'Retrieving financial statements…'
    : reason || (disabled ? 'Financial statements are temporarily unavailable.' : '');

  const handleClick = () => {
    if (!isDisabled && hasAction) onGetFinancials();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
      <Button
        variant="contained"
        onClick={handleClick}
        disabled={isDisabled}
        aria-busy={isLoading}
        aria-describedby={descriptionId}
        startIcon={isLoading
          ? <CircularProgress size={16} color="inherit" aria-hidden="true" />
          : <CloudDownloadOutlinedIcon />}
        sx={{ textTransform: 'none', borderRadius: '8px', whiteSpace: 'nowrap' }}
      >
        {isLoading ? 'Getting financials…' : 'Get financials'}
      </Button>
      <Box id={descriptionId} role="status">
        <Typography variant="body2" color="text.secondary">
          Retrieve D&amp;B financial statements and save them in Financial Report.
        </Typography>
        {status && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{status}</Typography>}
      </Box>
    </Box>
  );
}
